import React from "react";
import { getFormmatedDate, getFormmatedDateTime } from "../../utils/helper";
import "./styles/PreviewPatientSampleInformation.css";

const PreviewPatientSampleInformation = ({
  orderDate,
  collectedDate,
  collectedTime,
  patientSampleType,
  reportedDate,
  sampleID,
  institutionSampleID,
}: any) => {
  return (
    <div className="order-table">
      <div className="box patient-sample-info-box">
        <div className="box-header">
          <span>Patient sample information</span>
          <div className="bottom-line"></div>
        </div>
        <div className="box-content">
          <div className="field-value">
            <div className="field">Ordered:</div>
            <div className="inner-value">{orderDate ? getFormmatedDate(orderDate) : ""}</div>
          </div>
          <div className="under-line"></div>
          <div className="field-value">
            <div className="field">Collected:</div>
            <div className="inner-value">
              {collectedDate
                ? getFormmatedDateTime(collectedDate, collectedTime)
                : ""
              }
            </div>
          </div>
          <div className="under-line"></div>
          <div className="field-value">
            <div className="field">Type:</div>
            <div className="inner-value">{patientSampleType}</div>
          </div>
          <div className="under-line"></div>
          <div className="field-value">
            <div className="field">Reported:</div>
            <div className="inner-value">{reportedDate ? getFormmatedDate(reportedDate) : ""}</div>
          </div>
          <div className="under-line"></div>
          <div className="field-value">
            <div className="field">Sample ID:</div>
            <div className="inner-value">{sampleID}</div>
          </div>
          <div className="under-line"></div>
          <div className="field-value">
            <div className="field">Institution sample ID:</div>
            <div className="inner-value">{institutionSampleID}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPatientSampleInformation;
